import { combineReducers, configureStore } from '@reduxjs/toolkit';

import adsReducer from './slices/campaigns/adsSlice';
import campaignsReducer from './slices/campaigns/campaignsSlice';
import campaignsStatReducer from './slices/campaigns/campaignsStatSlice';
import campaignsFiltersReducer from './slices/campaigns/select/filters/filtersSlice';
import campaignsNamesReducer from './slices/campaigns/select/names/namesSlice';
import deviceProfilesReducer from './slices/device-profiles/deviceProfilesSlice';
import devicesMapGpsSlice from './slices/devices/devicesMapGpsSlice';
import devicesMapReducer from './slices/devices/devicesMapSlice';
import devicesOverviewReducer from './slices/devices/devicesOverviewSlice';
import devicesReducer from './slices/devices/devicesSlice';
import devicesTableReducer from './slices/devices/devicesTableSlice';
import devicesIdsReducer from './slices/devices/ids/devicesIdsSlice';
import devicesFiltersReducer from './slices/devices/select/filters/devicesFiltersSlice';
import geosReducer from './slices/geos/geosSlice';
import historyReducer from './slices/historySlice';
import incidentTypesReducer from './slices/incident-types/incidentTypesSlice';
import aggregatedIncidentsCarReducer from './slices/incidents/aggregatedIncidentsCarSlice';
import aggregatedIncidentsTimeReducer from './slices/incidents/aggregatedIncidentsTimeSlice';
import incidentsReducer from './slices/incidents/incidentsSlice';
import operatorsReducer from './slices/operators/operatorsSlice';
import orgsReducer from './slices/orgs/orgsSlice';
import parksReducer from './slices/parks/parksSlice';
import reportNamesReducer from './slices/reports/filters/names/namesSlice';
import reportTypesReducer from './slices/reports/filters/types/typesSlice';
import generateReportReducer from './slices/reports/report/generated/generatedReportSlice';
import reportsReducer from './slices/reports/table/reportsSlice';
import settingsReducer from './slices/settings/settingsSlice';
import snackReducer from './slices/snackSlice';
import aggrDeviceByAvgFieldReducer from './slices/stat/aggr/aggrDeviceByAvgFieldSlice';
import aggrDeviceByMileageFieldReducer from './slices/stat/aggr/aggrDeviceByMileageFieldSlice';
import aggrDeviceBySumAdTimeFieldReducer from './slices/stat/aggr/aggrDeviceBySumAdTimeFieldSlice';
import aggrDeviceBySumFieldReducer from './slices/stat/aggr/aggrDeviceBySumFieldSlice';
import aggrDeviceByTimeFieldReducer from './slices/stat/aggr/aggrDeviceByTimeFieldSlice';
import aggrDeviceReducer from './slices/stat/aggr/aggrDeviceSlice';
import aggrFiltersSlice from './slices/stat/aggr/aggrFiltersSlice';
import aggrPlaysByAdReducer from './slices/stat/aggr/aggrPlaysByAdSlice';
import aggrPlaysByDayReducer from './slices/stat/aggr/aggrPlaysByDaySlice';
import aggrTabletRidesByDayReducer from './slices/stat/aggr/aggrTabletRidesByDaySlice';
import aggrTotalPlaysByAdReducer from './slices/stat/aggr/aggrTotalPlaysByAdSlice';
import aggrStaticSidesDeviceSlice from './slices/stat/static/aggr/graphics/aggrStaticSidesDeviceSlice';
import staticAggrDeviceByMileageFieldSlice
  from './slices/stat/static/aggr/graphics/staticAggrDeviceByMileageFieldSlice';
import staticAggrDeviceBySumAdTimeFieldSlice
  from './slices/stat/static/aggr/graphics/staticAggrDeviceBySumAdTimeFieldSlice';
import staticAggrDeviceBySumFieldSlice from './slices/stat/static/aggr/graphics/staticAggrDeviceBySumFieldSlice';
import staticAggrDeviceByTimeFieldSlice from './slices/stat/static/aggr/graphics/staticAggrDeviceByTimeFieldSlice';
import staticAggrAirtimeByDaySlice from './slices/stat/static/aggr/staticAggrAirtimeByDaySlice';
import staticAggrMileageByDaySlice from './slices/stat/static/aggr/staticAggrMileageByDaySlice';
import staticAggrPlaysByAdSlice from './slices/stat/static/aggr/staticAggrPlaysByAdSlice';
import staticAggrTotalSlice from './slices/stat/static/aggr/staticAggrTotalSlice';
import statStaticAdFiltersSlice from './slices/stat/static/filters/statStaticAdFiltersSlice';
import staticAdvFormReducer from './slices/static-adv-form/staticAdvFormSlice';
import staticDevicesFiltersSlice from './slices/static-devices/select/filters/devicesFiltersSlice';
import surfaceTypesReducer from './slices/surface-types/surfaceTypesSlice';
import themeReducer from './slices/themeSlice';
import currentUserLogoReducer from './slices/users/current/currentUserLogoSlice';
import currentUserReducer from './slices/users/current/currentUserSlice';
import usersReducer from './slices/users/usersSlice';

const rootReducer = combineReducers({
  themeReducer,
  historyReducer,
  snackReducer,
  devicesReducer,
  devicesOverviewReducer,
  devicesMapReducer,
  devicesMapGpsSlice,
  devicesTableReducer,
  devicesIdsReducer,
  devicesFiltersReducer,
  staticDevicesFiltersSlice,
  settingsReducer,
  campaignsReducer,
  adsReducer,
  geosReducer,
  campaignsFiltersReducer,
  campaignsNamesReducer,
  incidentTypesReducer,
  incidentsReducer,
  aggregatedIncidentsTimeReducer,
  aggregatedIncidentsCarReducer,
  aggrDeviceReducer,
  aggrDeviceByTimeFieldReducer,
  aggrDeviceByMileageFieldReducer,
  aggrDeviceBySumFieldReducer,
  aggrDeviceBySumAdTimeFieldReducer,
  aggrDeviceByAvgFieldReducer,
  aggrPlaysByDayReducer,
  aggrPlaysByAdReducer,
  aggrTotalPlaysByAdReducer,
  aggrTabletRidesByDayReducer,
  staticAdvFormReducer,
  parksReducer,
  operatorsReducer,
  usersReducer,
  currentUserReducer,
  currentUserLogoReducer,
  orgsReducer,
  surfaceTypesReducer,
  deviceProfilesReducer,
  campaignsStatReducer,
  statStaticAdFiltersSlice,
  staticAggrPlaysByAdSlice,
  staticAggrMileageByDaySlice,
  staticAggrAirtimeByDaySlice,
  staticAggrTotalSlice,
  aggrFiltersSlice,
  staticAggrDeviceByTimeFieldSlice,
  staticAggrDeviceByMileageFieldSlice,
  staticAggrDeviceBySumFieldSlice,
  staticAggrDeviceBySumAdTimeFieldSlice,
  aggrStaticSidesDeviceSlice,
  reportNamesReducer,
  reportTypesReducer,
  reportsReducer,
  generateReportReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;
